import { iterator as Symbol_iterator } from '../symbol/iterator';
export function isIterable(input) {
  return input && typeof input[Symbol_iterator] === 'function';
}
